import React from 'react'
import createReactClass from 'create-react-class'
import '../search-page/search-form-panel.scss'
import {TranslationsFormData, getDefaultLocale} from '@/util/helpers'
import './translations.css'

export default createReactClass({
  getInitialState () {
    return {
      params: {...TranslationsFormData.initialParams},
      selectedLanguage: getDefaultLocale(this.props.languageAccess),
      selectedResourceSet: '',
    }
  },
  resetForm (e) {
    e.preventDefault()
    this.setState({
      params: {...TranslationsFormData.initialParams},
      selectedLanguage: getDefaultLocale(this.props.languageAccess),
      selectedResourceSet: '',
    })
  },
  searchTranslations (e) {
    e.preventDefault()
    let data = this.state.params
    data['locale'] = this.state.selectedLanguage
    this.setState({params: {...data}})
    this.props.getTranslationsData(this.state.params)
  },
  update (e, paramField) {
    if (paramField === 'locale') this.setState({selectedLanguage: e.target.value})
    if (paramField === 'resourceSet') this.setState({selectedResourceSet: e.target.value})
    let data = this.state.params
    data[paramField] = e.target.value
    this.setState({params: {...data}})
  },
  render () {
    if (this.props.languageAccess.length > 0) {
      return (
        <div className="search-form-panel">
          <form>
            <div className='flex-container'>
              <div className="search-boxes">
                <div className="search-box-description">{'Please Select a Language'}</div>
                <div className="search-box-content">
                  <div className="search-box-items">
                    { this.props.languageAccess.map((lang, index) => {
                      return TranslationsFormData.supportedLanguages.map((value, index) => {
                        return <ul className='render-list' key={index}>
                          {(value.code === (lang === 'GB' ? 'EN' : lang)) ? <li key={value.name}><input type='radio' name='language' value={value.code}
                            onChange={(e) => this.update(e, 'locale')}
                            style={{cursor: 'pointer'}}
                            checked={this.props.languageAccess.length === 1 ? true : this.state.selectedLanguage === value.code}/>{value.language}
                          </li>
                            : null}
                        </ul>
                      })
                    }
                    )}
                  </div>
                </div>
              </div>
              <div className="search-boxes">
                <div className="search-box-description">{'Select a Resource Set (optional)'}</div>
                <div className="search-box-content">
                  <div className="search-box-items">
                    {TranslationsFormData.supportedResourceSets.map((resourceSet, index) => {
                      return <ul className='render-list' key={index}>
                        {<li key={resourceSet.key}><input type='radio' name='resourceSet' value={resourceSet.key}
                          onChange={(e) => this.update(e, 'resourceSet')}
                          style={{cursor: 'pointer'}}
                          checked={this.state.selectedResourceSet === resourceSet.key}/>
                        {resourceSet.name}
                        </li>
                        }
                      </ul>
                    })
                    }
                  </div>
                </div>
              </div>
              <div className="search-boxes">
                <div className="search-box-description search-item">{'Enter a search term (optional)'}</div>
                <textarea className='search-item-content'
                  onChange={(e) => this.update(e, 'searchText')} wrap="soft"
                  value={this.state.params.searchText}/>
              </div>
            </div>
            <div className='pull-right'>
              <button type='reset' className='cs-grey-button' onClick={this.resetForm}>Clear</button>
              <button type='submit' className='cs-primary-button' onClick={this.searchTranslations}
                disabled={this.props.loader}>
                {this.props.loader ? <i className="fa fa-spinner fa-spin"></i> : ''}Find
              </button>
            </div>
          </form>
        </div>
      )
    } else {
      setTimeout(() => {
        if (this.props.languageAccess.length <= 0) this.props.history.push('/search')
      }, 1200)
      return null
    }
  },
  componentDidUpdate (prevProps) {
    if (prevProps.languageAccess !== this.props.languageAccess) {
      this.setState({selectedLanguage: getDefaultLocale(this.props.languageAccess)})
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/monitoring-translations/translations-form-panel.js